import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import { Field } from 'redux-form';
import classname from 'classname';
import PropTypes from 'prop-types';

import forEach from 'lodash/forEach';
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
import values from 'lodash/values';

import checkboxField from '../../../shared/form-elements/checkbox';
import radioField from './radio-field';
import Tooltip from '../../../shared/tooltip';
import Animated from '../../../shared/animation';
import ImagePlaceholdered from '../../../shared/image-placeholdered';
import { mapTableSortHeaders, showMoreRows } from '../../../shared/table-helpers';
import OfferPromoLabels from '../../../shared/offer-promo-labels';
import DownloadLanding from './download-landing';

lessRequire('modules/streams/components/display-type/tile.less');

const Tile = (props) => {
	const {
		data,
		type,
		isOtherAdv,
		isEditMode,
		canEdit,
		tableHeaders,
		sortByColumn,
		columnSorting,
		showMore,
		shouldShowSplitTooltip,
		formData,
		intl,
		checkLandingsPopups,
		selectedLandings,
		streamId,
		user
	} = props;
	return (
		<div className={shouldShowSplitTooltip ? 'stream-table-wrapper' : ''}>
			<div className="tile-view">
				<Animated>
					<table className="dashboard-table">
						<thead className="dashboard-table__head tile-view__header font-proxima-nova-semibold">
							<tr>
								{mapTableSortHeaders({
									headers: values(tableHeaders.tile),
									columnSorting,
									sortByColumn: e => sortByColumn(e, 'tile'),
									intl
								}).map((header, i) => <th key={i} className={i > 0 ? 'value padding-right-none' : ''}>{header}</th>)}
							</tr>
						</thead>

						<tbody className="dashboard-table__body tile-view__body">
							<tr>
								<td colSpan="3">
									{getItems({
										rows: data.paginated.data,
										isOtherAdv,
										isEditMode,
										canEdit,
										offerGeoStats: props.offerGeoStats,
										type,
										fields: formData && formData.values || {},
										intl,
										checkLandingsPopups,
										streamId,
										selectedLandings,
										user
									})}
								</td>
							</tr>
							{!data.paginated.isCanNotMoveToNext && data.paginated.data.length
						&& showMore ? showMoreRows(showMore, `${capitalize(type)}Table`, intl) : null
							}
						</tbody>
					</table>
				</Animated>
			</div>
			{ shouldShowSplitTooltip && (
				<Tooltip>
					<span>{intl('При сохранении будет сгенерирован новый ключ сплит-сессии.')}</span>
				</Tooltip>
			)}
		</div>
	);
};

const getItems = ({rows, isOtherAdv, isEditMode, canEdit, type, fields,
	intl, checkLandingsPopups, streamId, selectedLandings, user, offerGeoStats}) => {

	const result = [];

	forEach(rows, (row, i)=> {
		if (!isOtherAdv && isEditMode && row.id !== selectedLandings[0])
			return;
		const shouldAddSeparator = !(++i % 5);
		const activeLand = fields && isOtherAdv
			? fields[`landing_pages_id_${row.id}`] == true
			: fields.landing_pages == row.id;
		const activeTransit = fields && fields[`transit_pages_id_${row.id}`] == true;

		const previewClasses = ['preview__landing'];
		if ((type === 'landings' && activeLand) ||
				(type !== 'landings' && activeTransit)) {
			previewClasses.push('active');
		}
		if (isEditMode && !canEdit) previewClasses.push('not-editable');

		const checkboxWrapclasses = type === 'landings'
			? activeLand ? 'checkbox-wrap active' : 'checkbox-wrap'
			: activeTransit ? 'checkbox-wrap active' : 'checkbox-wrap';

		const controlId = isOtherAdv ?
			type === 'landings' ? `landing_pages_id_${row.id}` :`transit_pages_id_${row.id}`:
			type === 'landings' ? `landing_pages${row.id}` : `transit_pages${row.id}`;

		result.push(
			<div key={i} className={classname({
				'tile-view__body-item': true,
				'padding-right-none': shouldAddSeparator
			})}>

				<label htmlFor={controlId}>
					<OfferPromoLabels intl={intl} labels={row.labels} />
					<ImagePlaceholdered
						src={row.image}
						alt={type == 'landings' ? 'Landing Preview' : 'Transit Preview'}
						className={previewClasses.join(' ')}
					/>
					{ isOtherAdv ?
						(
							<Field className={checkboxWrapclasses}
								name={type === 'landings' ? `landing_pages_id_${row.id}` :`transit_pages_id_${row.id}` }
								shouldCheck={type === 'landings' ? activeLand : activeTransit}
								component={checkboxField}
								onChange={e=> type === 'landings' &&  checkLandingsPopups(row.id, !e.target.value)}
								shouldDisable={isEditMode && !canEdit}/>
						) : (
							<Field name={type === 'landings' ? 'landing_pages' : 'transit_pages' }
								defaultValue={String(row.id)}
								shouldDisable={(!isOtherAdv && isEditMode) || (isEditMode && !canEdit)}
								component={radioField} />
						)
					}
				</label>

				<a className="link" href={'http://'+row.domain} target="_blank">
					<h3 className="title font-proxima-nova-semibold">
						{row.title} {row.removed && '(removed)'}
					</h3>
				</a>

				<div className="meta">
					<DownloadLanding
						language={fields.language && fields.language.value}
						domain={row.domain}
						landing_id={row.id}
						intl={intl}
						isEditMode={isEditMode}
						streamId={streamId}
						offerGeoStats={offerGeoStats}
						type={row.type}
						campaignCountryCode={fields.country_code}
					/>
				</div>
				{
					get(user, 'language') === 'ru' &&
						row.is_mt_approved &&
						<div className='mt_approved'> Одобрено в МТ </div>
				}
			</div>
		);

		if (shouldAddSeparator) {
			result.push(<div key={`sep-${i}`} className="tile-view-items-separator" />);
		}
	});
	return result;
};

Tile.propTypes = {
	data: PropTypes.object,
	type: PropTypes.string,
	isOtherAdv: PropTypes.bool,
	isEditMode: PropTypes.bool,
	canEdit: PropTypes.bool,
	sortByColumn: PropTypes.func,
	activeSortColumn: PropTypes.object,
	rowsNumber: PropTypes.number,
	totalRows: PropTypes.number,
	tableHeaders: PropTypes.object,
	columnSorting: PropTypes.object,
	isCanNotMoveToNext: PropTypes.bool,
	showMore: PropTypes.func,
	shouldShowSplitTooltip: PropTypes.bool,
	formData: PropTypes.object,
	intl: PropTypes.func,
	checkLandingsPopups: PropTypes.func,
	streamId: PropTypes.string,
	selectedLandings: PropTypes.array,
	user: PropTypes.object
};

export default Tile;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/display-type/tile.js